/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { message, Button, Spin, Alert, Select } from "antd";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { tripsApi } from "../../apis";

const { Option } = Select;
export const EditTrip = () => {
  const { id } = useParams();
  const history = useHistory();
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  useEffect(() => {
    tripsApi
      .getById(id)
      .then((trip) =>
        setFormData({
          name: trip.name || "",
          description: trip.description || "",
          startDate: trip.startDate || "",
          endDate: trip.endDate || "",
          startTime: trip.startTime || "",
          endTime: trip.endTime || "",
        }),
      )
      .catch(() => message.error("Failed to load trip"))
      .finally(() => setFetching(false));
  }, [id]);

  const handleChange = (e) =>
    setFormData((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return message.error("Trip name is required");
    try {
      setLoading(true);
      await tripsApi.update(id, formData);
      message.success("Trip updated");
      history.push(`/trips/${id}`);
    } catch (e) {
      const msg = e.response?.data?.message;
      if (Array.isArray(msg)) msg.forEach((m) => message.error(m));
      else message.error(msg || "Failed to update");
    } finally {
      setLoading(false);
    }
  };

  if (fetching)
    return (
      <div className="main-wrapper">
        <Header onMenuClick={() => {}} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div style={{ textAlign: "center", padding: "80px 0" }}>
              <Spin size="large" />
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Edit Trip</h5>
                  <Button onClick={() => history.goBack()}>Back</Button>
                </div>
              </div>
              <Alert
                message="Changing the start or end date will regenerate all schedule dates for this trip."
                type="warning"
                showIcon
                className="mb-4"
              />
              <form onSubmit={handleSubmit}>
                <div className="form-group-item">
                  <h5 className="form-title">Trip Details</h5>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Trip Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input-block mb-3">
                        <label>Description</label>
                        <input
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="startDate"
                          value={formData.startDate}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={formData.endDate}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div> */}
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>Default Start Time</label>
                        <input
                          type="time"
                          className="form-control"
                          name="startTime"
                          value={formData.startTime}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>Default End Time</label>
                        <input
                          type="time"
                          className="form-control"
                          name="endTime"
                          value={formData.endTime}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group-item border-0">
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-primary cancel me-2"
                      onClick={() => history.goBack()}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Saving…
                        </>
                      ) : (
                        "Save Changes"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditTrip;
